/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DigitizePointService } from '../digitize-point.service';
import { map } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import { DigitizableLayer } from '../state/digitize-point-config.model';

@Component({
    selector: 'dash-gis-digitize-dialog',
    templateUrl: './digitize-point-dialog.component.html',
    styleUrls: [
        './digitize-point-dialog.component.scss',
    ],
})
export class DigitizePointDialogComponent {
    public selectedLayer: string;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialogRef: MatDialogRef<DigitizePointDialogComponent>,
        private digitizeService: DigitizePointService,
        private store: Store,
    ) {}


    chooseLayer() {
        this.dialogRef.close(this.selectedLayer);
    }

    canCreatePoints() {
        return this.data.layers.length > 0;
    }

    canCreatePoint$(layerName) {
        return this.digitizeService.canCreatePoint$(layerName).pipe(
            map((val) => this.canCreatePoints() && val)
        );
    }

    getSelectionHelpText(layer: DigitizableLayer): string {
        return layer.requireSelection
            ? ` Select a feature on '${layer.requireSelection}.'`
            : '';
    }

    cancel() {
        this.dialogRef.close();
    }
}
